import React, { createContext, useContext, useEffect, useRef, useState } from 'react';
import AppHeader from '../../components/AppHeader/AppHeader';
import AppFooter from '../../components/AppFooter/AppFooter';
import { ProfileHeader } from '../../components/Profile/ProfileHeader/ProfileHeader';
import styles from './ProfileEditable.module.scss';

import ContestStats from '../../components/Community/ContestStats/ContestStats';

import { IconProp } from '@fortawesome/fontawesome-svg-core';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { faCalendar } from '@fortawesome/free-regular-svg-icons';
import { faCircle, faMapMarkerAlt, faXmark } from '@fortawesome/free-solid-svg-icons';
import 'react-bootstrap-country-select/dist/react-bootstrap-country-select.css';

//Header Data
import headerimg from '../../assets/header_placeholder_transparent.png';
import headerLogo from '../../assets/desall_logo.png';
import { clientlProfileNavPages, personalProfileNavPages } from '../../mockdata/navPages';
import { PageNavigationProfileEditable } from '../../components/PageNavigation/PageNavigation';

//Footer Data
import footerImg from '../../assets/footer_placeholder_transparent.png';

//Styles

import { ProfilePic } from '../../components/Profile/ProfilePic/ProfilePic';
import { useStoreState } from 'pullstate';
import DslStore, {
  setClientContest,
  setClientContestNumber,
  setCommunityUser,
  setCurrentUser,
  setPortfolioDesign,
  setPortfolioDesignCopy,
  setUserAwards,
  setUserInspirations,
  setUserInspirationsCopy,
} from '../../store/DslStore';
import { getCommunityUser, getCurrentUser, getFooterMenu, getHeaderMenu } from '../../store/Selectors';
import { finalSlicedString, fullPathLogo, locationString, registrationDateString } from '../../helpers/utils';

import { Contest, UserDetails, UserFavorites, ContestTag, User } from '../../global';

import axiosHelper from '../../helpers/axiosHelper';
import 'react-modern-calendar-datepicker/lib/DatePicker.css';
import UpdatePassword from '../../components/ProfileEditable/UpdatePassword/UpdatePassword';
import NewsletterAndNotifications from '../../components/ProfileEditable/Newsletter&Notifications/Newsletter&Notifications';
import YourProfessionalProfile from '../../components/ProfileEditable/YourProfessionalProfile/YourProfessionalProfile';
import YourProfile from '../../components/ProfileEditable/YourProfile/YourProfile';
import { MyUserContext } from '../../UserContext';

interface DatePickerVal {
  day: number;
  month: number;
  year: number;
}

interface ProfileProps {
  breadcrumbs: (breadcrumbs: string) => void;
  successBanner: (success: number) => void;
}

const ProfileEditable: React.FC<ProfileProps> = (props) => {
  const currentUser = useStoreState(DslStore, getCurrentUser);
  const [profileImage, setProfileImage] = useState<string | undefined>(
    fullPathLogo(currentUser?.logoAttachment?.s3Path)
  );
  const [bannerImage, setBannerImage] = useState<string | undefined>(
    fullPathLogo(currentUser?.bannerAttachment?.s3Path)
  );
  const [successBanner, setSuccessBanner] = useState(0);
  const communityUser = useStoreState(DslStore, getCommunityUser);

  const [image, setImage] = useState(currentUser?.idLogo);
  const [banner, setBanner] = useState(currentUser?.idBanner);
  const [open, setOpen] = useState(0);

  const imageAdded = useRef<string>('');

  const [getPreviewProfile, setGetPreviewProfile] = useState(false);
  const [getPreviewProfessional, setGetPreviewProfessional] = useState(false);

  useEffect(() => {
    props.breadcrumbs && props.breadcrumbs('Edit Profile');
  }, []);

  const setUserDetails = async (userId?: number) => {
    currentUser?.userType === 'D'
      ? await axiosHelper.getDesignerDetails(userId)?.then(async (design) => {
          await axiosHelper.getDesignerAwards(userId)?.then((awards) => {
            setUserAwards(awards.awards);
          });
          await axiosHelper.getDesignerInspirations(userId)?.then((inspirations) => {
            setUserInspirations(inspirations.inspirations);
          });
          setPortfolioDesign(design.designs);
          setPortfolioDesignCopy(design.designs);
        })
      : await axiosHelper.getUserDetails(userId)?.then(async (design) => {
          await axiosHelper.getUserAwards(userId)?.then((awards) => {
            setUserAwards(awards.awards);
          });
          await axiosHelper.getUserInspirations(userId)?.then((inspirations) => {
            setUserInspirations(inspirations.inspirations);
          });
          setPortfolioDesign(design.designs);
          setPortfolioDesignCopy(design.designs);
        });
    // if (result) {
    //   setUserInspirations(result.inspirations);
    //   setUserInspirationsCopy(result.inspirations);
    //   setUserAwards(result.awards);
    //   setPortfolioDesign(result.designs);
    //   setPortfolioDesignCopy(result.designs);
  };

  const setClientContests = async () => {
    let result = await axiosHelper.getContestsByClientId(communityUser?.id);
    const clientContests: Contest[] = result.data;
    if (clientContests) {
      setClientContest(clientContests);
    }
  };

  const userContestNumber = () => {
    if (communityUser) {
      let clientContestLength: number = communityUser.contests.length;
      console.log(clientContestLength);
      setClientContestNumber(clientContestLength);
    }
  };

  const handleImageAdd = (e: string) => {
    console.log(e);
    setImage(e);
    imageAdded.current = e;
    console.log(imageAdded.current);
  };

  const handleBannerAdd = (e: any) => {
    console.log(e);
    // setBannerImage(e);
    setBanner(e);
  };

  useEffect(() => {
    setCommunityUser(currentUser);
    setPortfolioDesign([]);
    console.log(currentUser);
    console.log(communityUser);
  }, []);

  useEffect(() => {
    if (communityUser?.userType === 'C') {
      userContestNumber();
      setClientContests();
    }
    setUserDetails(communityUser?.id);
  }, [communityUser]);

  return (
    <div className="bg-light-gray">
      <main className={`${styles.profileWrapper} container  px-sm-0  `}>
        <div className="row ">
          {/* Left column  ====================================================== */}
          <div className="col-12 col-md-3 pt-5 ">
            {/* <div className="buttons">
              <button className="btn-blue rounded full mt-7 mb-3">Add to favorite</button>
              <button className="btn-blue rounded full mb-3">Send message</button>
              <button className="btn-red rounded big full mb-3">Block</button>
            </div> */}
            {communityUser?.tags &&
              communityUser?.tags.map((item: ContestTag, index: number) => (
                <>
                  <button className="btn-tag mb-4 px-0 me-5 ">
                    <span>{item.name.replace(',', '')}</span>
                  </button>
                </>
              ))}
            {/* <div className="tags  d-flex flex-wrap">
              <button className="btn-tag mb-4 me-4">
                <span>Even more Looooong stuff</span>
              </button>
              <button className="btn-tag  mb-4">
                <span>Short</span>
              </button>
              <button className="btn-tag  mb-4">
                <span>The</span>
              </button>
              <button className="btn-tag  mb-4">
                <span>The medium</span>
              </button>
            </div> */}
          </div>
          <div className="col-12 col-md-9">
            <div className="row pt-5">
              <div className="col-12 ps-5  ">
                <YourProfile
                  upload={(n) => props.successBanner(n)}
                  preview={getPreviewProfessional}
                  sendPreview={(e) => (console.log('send profile'), setGetPreviewProfile(e))}
                  open={(open: number) => setOpen(open)}
                  isOpen={open === 1}
                />

                <YourProfessionalProfile
                  user={currentUser}
                  upload={(n) => props.successBanner(n)}
                  preview={getPreviewProfile}
                  sendPreview={(e) => (console.log('send professional'), setGetPreviewProfessional(e))}
                  open={(open: number) => (
                    setOpen(open)
                  )}
                  isOpen={open === 2}
                />

                <NewsletterAndNotifications
                  user={currentUser}
                  upload={(n) => props.successBanner(n)}
                  open={(open: number) => (
                    setOpen(open)
                  )}
                  isOpen={open=== 3}
                />

                <UpdatePassword
                  upload={(n) => props.successBanner(n)}
                  open={(open: number) => setOpen(open)}
                  isOpen={open === 4}
                />
              </div>
            </div>
          </div>
        </div>
      </main>
      {/* <AppFooter links={footerMenu} bgColor="#304053" logoImg={headerLogo} bgImage={footerImg} /> */}
    </div>
  );
};

export default ProfileEditable;
